export const BOT_STATUS_TYPE = {
	ONLINE: 'online',
	OFFLINE: 'offline',
	TRIAL: 'test_ready',
	UNAVAILABLE: 'unavailable',
	MISSION_READY: 'mission_ready',
	PERSONAL_READY: 'personal_ready',
	MISSION_IN_PROGRESS: 'mission_in_progress'
};
